import { Injectable } from '@angular/core';
import { Decorable } from '../types/decorable';
import { ButtonComponent, ButtonInfo } from '../components/button/button.component';
import { ButtonProxyComponent } from '../components/button/button-proxy/button-proxy.component';
import { ButtonSetComponent } from '../components/button/button-set/button-set.component';


export type ButtonGroupInfo = {
	buttons: Array<ButtonComponent>;
	selection: number | false;
}

export type ButtonGroups = {
	[key: string]: ButtonGroupInfo
}
export type ButtonSets = {
	[key: string]: ButtonSetComponent;
}

@Injectable({
	providedIn: 'root'
})
export class ButtonGroupService {

	private groups: ButtonGroups = {};
	private buttonSets: ButtonSets = {};
	constructor() {

	}
	GetButtonSet(group): ButtonSetComponent {
		return this.buttonSets[group];
	}
	RegisterButtonSet(name: string, buttonSet: ButtonSetComponent) {
		this.buttonSets[name] = buttonSet;
	}
	UnRegisterButtonSet(name: string) {
		delete this.buttonSets[name];
	}

	UnRegisterGroupButton(button: ButtonComponent, group: string) {
		if (this.groups && this.groups[group] && this.groups[group].buttons) {
			this.groups[group].buttons.every((groupButton: ButtonComponent, index: number, data: Array<ButtonComponent>) => {
				if (groupButton.id === button.id) {
					data.splice(index, 1);
					return false;
				}
				return true;
			});
		}
	}
	RegisterGroupButton(button: ButtonComponent, group: string) {
		if (!button.isToggleable) { return; }
		if (!this.groups[group]) {
			this.groups[group] = { buttons: [button], selection: button.isOn ? 0 : false }
		} else {
			const len = this.groups[group].buttons.length;
			let found = false;
			this.groups[group].buttons.every((buttonEntry: ButtonComponent, index: number) => {
				if (buttonEntry.id === button.id) {
					found = true;
					return false;
				}
				return true;
			});
			if (found === false) {
				this.groups[group].buttons.push(button);
				if (button.isOn) {
					this.groups[group].buttons.push(button);
				}
			}
		}
	}
	ToggleOffOthers(group: string, button: ButtonComponent) {
		if (!(!!this.groups && !!this.groups[group] && !!this.groups[group].buttons)) return;
		this.groups[group].buttons.every((groupButton: ButtonComponent) => {
			if (groupButton.id === button.id) return true;
			groupButton.Toggle(false, false);
			// groupButton.TriggerAction();
			return true;
		})
	}
	CloseAll() {
		for (const buttonSet of Object.values(this.buttonSets)) {
			buttonSet.Close();
		}
	}
	Toggle(buttonInfo: ButtonInfo) {
		if (this.groups && !!this.groups[buttonInfo.toggleGroup]) {
			this.groups[buttonInfo.toggleGroup].buttons.every((groupButton: ButtonComponent) => {
				if (groupButton.id === buttonInfo.guiId) {
					groupButton.isOn = buttonInfo.isOn;
					groupButton.RefreshView();
					this.ToggleOffOthers(buttonInfo.toggleGroup, groupButton);
					return false;
				}
				return true;
			})

		}
	}
}
